import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Components
import Login from './components/Login';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import ServiceCalls from './pages/ServiceCalls';
import Calendar from './pages/Calendar';
import Invoices from './pages/Invoices';
import Users from './pages/Users';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import HumanResources from './pages/HumanResources';
import MessageBoard from './pages/MessageBoard';
import Display from './pages/Display';
import Proposals from './pages/Proposals';
import ProposalForm from './pages/ProposalForm';
import ProposalDetail from './pages/ProposalDetail';
import ChangeOrders from './pages/ChangeOrders';
import ChangeOrderForm from './pages/ChangeOrderForm';
import ChangeOrderDetail from './pages/ChangeOrderDetail';
import WebsiteCMS from './pages/WebsiteCMS';
import WebsiteLeads from './pages/WebsiteLeads';
import ITSupport from './pages/ITSupport';
import LeadFinder from './pages/LeadFinder';
import SalesDashboard from './pages/SalesDashboard';

// Context
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Styles
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/display" element={<Display />} />
            
            {/* Protected Routes */}
            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }>
              <Route index element={<Dashboard />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="clients" element={<Clients />} />
              <Route path="service-calls" element={<ServiceCalls />} />
              <Route path="calendar" element={<Calendar />} />
              <Route path="invoices" element={<Invoices />} />
              
              {/* Proposals */}
              <Route path="proposals" element={<Proposals />} />
              <Route path="proposals/new" element={<ProposalForm />} />
              <Route path="proposals/edit/:id" element={<ProposalForm />} />
              <Route path="proposals/:id" element={<ProposalDetail />} />
              
              {/* Change Orders */}
              <Route path="change-orders" element={<ChangeOrders />} />
              <Route path="change-orders/new" element={<ChangeOrderForm />} />
              <Route path="change-orders/edit/:id" element={<ChangeOrderForm />} />
              <Route path="change-orders/:id" element={<ChangeOrderDetail />} />
              
              {/* Sales */}
              <Route path="lead-finder" element={<LeadFinder />} />
              <Route path="sales-dashboard" element={<SalesDashboard />} />
              <Route path="website-leads" element={<WebsiteLeads />} />

              {/* Website Management */}
              <Route path="website-cms" element={<WebsiteCMS />} />

              {/* IT Support */}
              <Route path="it-support" element={<ITSupport />} />
              <Route path="it-support/:ticketNumber" element={<ITSupport />} />

              <Route path="users" element={<Users />} />
              <Route path="reports" element={<Reports />} />
              <Route path="hr" element={<HumanResources />} />
              <Route path="message-board" element={<MessageBoard />} />
              <Route path="settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <ToastContainer 
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
